import React, { FC } from 'react';
import { useWatch } from 'react-hook-form';

import { ComponentType, getComponentFieldsAtPath, VoltageType } from 'models';

import { CurrentField } from 'components/component-fields/CurrentField';
import { PowerField } from 'components/component-fields/PowerField';
import { VoltageField } from 'components/component-fields/VoltageField';
import { Datasheet } from 'components/datasheet/Datasheet';

type ComponentDatasheetPortVoltageTypeProps = {
    index: number;
    label: React.ReactNode;
    voltageType: VoltageType;
};

const ComponentDatasheetPortVoltageType: FC<ComponentDatasheetPortVoltageTypeProps> = ({
    index,
    label,
    voltageType,
}) => {
    const type = useWatch({ name: 'type' }) as ComponentType;

    const key = `electrical.ports.${index}.${voltageType}`;

    const voltageFields = getComponentFieldsAtPath(type, `electrical.ports.${index}.${voltageType}`);

    return (
        <Datasheet.RowSpan
            header={{
                prefix: ['Electrical', label],
                label: `${voltageType} specifications`,
            }}
            color={`var(--mantine-color-${voltageType}-filled)`}
        >
            {'voltage' in voltageFields && (
                <Datasheet.TableRow name={`${key}.voltage`} label="Voltage" voltageType={voltageType}>
                    <VoltageField name={`${key}.voltage`} />
                </Datasheet.TableRow>
            )}
            {'current' in voltageFields && (
                <Datasheet.TableRow name={`${key}.current`} label="Current" voltageType={voltageType}>
                    <CurrentField name={`${key}.current`} />
                </Datasheet.TableRow>
            )}
            {'power' in voltageFields && (
                <Datasheet.TableRow name={`${key}.power`} label="Power" voltageType={voltageType}>
                    <PowerField name={`${key}.power`} />
                </Datasheet.TableRow>
            )}
        </Datasheet.RowSpan>
    );
};

export { ComponentDatasheetPortVoltageType };
